module.exports = __webpack_public_path__ + "img/9_ward_250.72c09fac.png";